import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestCodeModel } from '../typings/typing';

@Injectable({
  providedIn: 'root'
})
export class CustomerInfoService {
  constructor(private http: HttpClient) {}
  getShippingAddresses(params: any) {
    const headers = new HttpHeaders().set('isUserCenterAdmin', 'true');
    return this.http.post<RequestCodeModel>( '/masterData/address/page', params, { headers });
  }
}
